import { useTranslation } from "react-i18next";
import "../../../styles/mapStyles/Popup.css";

function RemoveMarkerBtn({ onRemoveMarker }) {
  const { t } = useTranslation();

  return (
    <button
      className="remove-marker-btn"
      onClick={(e) => {
        e.stopPropagation(); // prevents click from reaching the map and creating a new marker
        onRemoveMarker();
      }}
    >
      {t("soil.removeMarker")}
    </button>
  );
}

export default RemoveMarkerBtn;
